export enum ReplayViewMode {
  view = 'view',
  edit = 'edit',
  share = 'share'
}
